import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { DeleteOutlined, CloseOutlined, EditOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';

const Certification = ({ certification, index, removeCertification, openAddModal, columnId, isDragDisabled = false, isDragging = false }) => {
  return (
    <Draggable draggableId={certification.id} index={index} isDragDisabled={false}>
      {(provided, snapshot) => {
        const containerClass = classNames('card-container', {
          dragging: snapshot.isDragging,
          disabled: snapshot.isDropDisabled,
        });

        return (
          <div className={containerClass} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
            <div className="card">
              <div className="rightBtn">
                <Tooltip title={columnId === 'available' ? 'Permanently remove' : 'Move back to the certification list'}>
                  <span
                    onClick={() =>
                      removeCertification({
                        id: certification.id,
                        position: columnId,
                      })
                    }
                  >
                    {columnId === 'available' ? <DeleteOutlined /> : <CloseOutlined />}
                  </span>
                </Tooltip>
              </div>

              <div className="leftBtn">
                <Tooltip title="Edit" placement="top">
                  <span onClick={() => openAddModal(certification.id)}>
                    <EditOutlined />
                  </span>
                </Tooltip>
              </div>

              <div className="type">Certification</div>
              <div className="title">{certification.name}</div>
              <div className="details">
                {certification.organization} | {certification.level}
              </div>
            </div>
          </div>
        );
      }}
    </Draggable>
  );
};

export default Certification;
